import React from 'react';
import { Grid } from '@material-ui/core';
import { useParams } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';

import Content from 'src/components/Content';
import useGetRequest from 'src/hooks/useGetRequest';

import Button from 'src/components/Button';
import Loader from 'src/components/Loader';
import Activities from 'src/views/shared/Activities';
import TasksCard from 'src/views/shared/TasksCard';
import EngagementsForWorkflowLedger from './EngagementsForWorkflowLedger';

const WorkflowDashboard = () => {
  const { workflowId } = useParams();
  const { result: workflow, isLoading } = useGetRequest({
    url: `/automatic/workflows/${workflowId}/`,
    initialResult: { steps: [], edges: [] },
  });

  if (isLoading) return <Loader />;

  const breadcrumbs = [
    {
      title: 'Workflows',
      route: '/workflows',
    },
  ];

  const actions = (
    <Button look="primary" component={RouterLink} to={`/workflows/${workflowId}/process`}>
      Edit workflow
    </Button>
  );

  return (
    <Content title={workflow.name} breadcrumbs={breadcrumbs} maxWidth="lg" actions={actions}>
      <Grid container spacing={3} justify="center">
        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <EngagementsForWorkflowLedger workflowId={workflowId} />
            </Grid>
            <Grid item xs={12}>
              <TasksCard
                url={`/automatic/workflows/${workflowId}/tasks/`}
                seeAllRoute={`/workflows/${workflowId}/tasks`}
                title="Outstanding tasks"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Activities
            title="Recent activity"
            url={`/automatic/workflows/${workflowId}/events/`}
          />
        </Grid>
      </Grid>
    </Content>
  );
};

export default WorkflowDashboard;
